import React, { useEffect, useRef, useState, FC } from 'react';
import { TSubValueRow } from '../../../types/index.types';
import LeftMostCell from './leftMostCell';
import SpecCell from './specCell';

const FADE_TIME = 600;

const SubValueRow: FC<TSubValueRow> = ({ model, subObj, hide, subArr, accIndex, showHiddenRightCells, searchTerm }) => {
  const [hideRow, setHideRow] = useState(hide);
  const [fadeIn, setFadeIn] = useState(false);
  const prevHideRef = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const prevHide = prevHideRef.current;

    prevHideRef.current = hide;

    if (!prevHide && hide) {
      timerRef.current = setTimeout(() => {
        setHideRow(() => hide);
      }, FADE_TIME);
    }

    if (prevHide && !hide) {
      setHideRow(() => hide);
      setFadeIn(() => true);
      setTimeout(() => {
        setFadeIn(() => false);
      }, FADE_TIME);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [hide, setHideRow]);

  if (hideRow) return null;

  return (
    <tr key={subObj.title?.value}>
      {!model.hideRowsHeader && subObj.title?.value && (
        <td className="model-detail-specification-table__left-most-cell">
          <div
            className={`
              model-detail-specification-table__left-side-accordion-spec-title
              ${
                hide || subArr.length === accIndex + 1
                  ? 'model-detail-specification-table__left-side-accordion-spec-title--border-hidden'
                  : ''
              }
              model-detail-specification-table__cell-animation
              ${fadeIn ? 'model-detail-specification-table__cell-animation--show-animation' : ''}
              ${hide ? 'model-detail-specification-table__cell-animation--hide' : ''}
            `}
          >
            <LeftMostCell row={subObj} heading={model.heading} eyebrow={model.eyebrow} searchTerm={searchTerm} />
          </div>
        </td>
      )}
      {model.colHeadings?.map((spec, specIndex) => (
        <SpecCell
          key={`model-detail-specification-table-spec-${subObj.title?.value}-${spec.text}`}
          isShowIconOnCell={model?.showIconsOnCells}
          specIndex={specIndex}
          lastRow={subArr.length === accIndex + 1}
          subObj={subObj}
          heading={model.heading}
          eyebrow={model.eyebrow}
          hide={hide}
          fadeIn={fadeIn}
          showHiddenRightCells={showHiddenRightCells}
        />
      ))}
    </tr>
  );
};

export default React.memo(SubValueRow);
